import {createSvgIcon} from '../create-svg-icon';

export const ShortTextIcon = createSvgIcon(
  <path d="M4 9h16v2H4V9zm0 4h10v2H4v-2z" />
, 'ShortTextOutlined');
